import {
  getDisplayName,
  isProductType,
  type ProductTypeSlug,
} from "@/lib/generated/product-types";
import {
  inlineProductName,
  singularizeName,
} from "@/lib/price-index/product-naming";

export interface UnitNouns {
  readonly unitName: string;
  readonly unitNamePlural: string;
}

const UNIT: UnitNouns = { unitName: "unit", unitNamePlural: "units" };
const ROLL: UnitNouns = { unitName: "roll", unitNamePlural: "rolls" };
const BOX: UnitNouns = { unitName: "box", unitNamePlural: "boxes" };

const UNCOUNTABLE_TYPE_NOUNS: Partial<Record<ProductTypeSlug, UnitNouns>> = {
  lumber: { unitName: "board", unitNamePlural: "boards" },
  equipment: UNIT,
  "stretch-wrap": ROLL,
  strapping: ROLL,
  "pallet-staples": BOX,
  "lumber-nails": BOX,
  "lumber-screws": { unitName: "pack", unitNamePlural: "packs" },
};

function isOverridden(
  slug: string,
): slug is keyof typeof UNCOUNTABLE_TYPE_NOUNS {
  return Object.hasOwn(UNCOUNTABLE_TYPE_NOUNS, slug);
}

export function productUnitNouns(
  productTypeSlug: string | null | undefined,
): UnitNouns {
  if (!productTypeSlug || !isProductType(productTypeSlug)) return UNIT;
  if (isOverridden(productTypeSlug)) {
    return UNCOUNTABLE_TYPE_NOUNS[productTypeSlug] ?? UNIT;
  }
  const plural = getDisplayName(productTypeSlug, true)?.trim();
  if (!plural) return UNIT;
  return {
    unitName: inlineProductName(singularizeName(plural)),
    unitNamePlural: inlineProductName(plural),
  };
}
